import React, { useEffect, useState, useContext } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  Card,
  Box,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  IconButton,
  Button,
  Grid,
  Alert,
  Tooltip,
  Chip,
  Badge
} from '@mui/material';
import { Visibility, Edit,PictureAsPdf, Delete, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import PaymentIcon from "@mui/icons-material/Payment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import contribuenteApi from '../../api/contribuenteApi';
import documentoApi from '../../api/documentoApi';
import scadenzaApi from '../../api/scadenzaApi';
import { scadenzaStatusMap } from '../../utils/scadenzaStatusMapper';
import filesApi from '../../api/filesApi';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../../components/ConfirmDeleteModal';
import ProtectedAction from '../../components/ProtectedAction';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';

const extractErrorMessage = (error) => {
  if (!error) return '';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};

export default function DashboardContribuenteDesktop() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [contribuente, setContribuente] = useState(null);
  const [documenti, setDocumenti] = useState([]);
  const [scadenze, setScadenze] = useState([]);
  const { user } = useContext(AuthContext);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteType, setDeleteType] = useState('');
  const [sortField, setSortField] = useState('tipo');
  const [sortDirection, setSortDirection] = useState('ASC'); // ASC o DESC

  const pageSize = 5; // per liste rapide
  const [scadenzeProssimeEntrata, setScadenzeProssimeEntrata] = useState(0);
  const [scadenzeScaduteEntrata, setScadenzeScaduteEntrata] = useState(0);
  const [scadenzeProssime, setScadenzeProssime] = useState(0);
  const [scadenzeScadute, setScadenzeScadute] = useState(0);
  const [listscadenzeprossime, setListScadenzeProssime] = useState([]);
  const [listscadenzescadute, setListScadenzeScadute] = useState([]);
  const [listscadenzeprossimeentrata, setListScadenzeProssimeEntrata] = useState([]);
  const [listscadenzescaduteentrata, setListScadenzeScaduteEntrata] = useState([]);

  useEffect(() => {
    fetchContribuente();
    fetchScadenze();
    fetchDocumenti();
  }, [id]);
  const fetchContribuente = () => {
    contribuenteApi.getMyContribuente()
      .then(r => setContribuente(r.data))
      .catch(err =>
      console.error("Errore caricamento contribuente:", err));
      setErr(extractErrorMessage(err));
  };

  const fetchDocumenti = async () => {
    try {
      const res = await documentoApi.listbycontribuente(id, { page: 0, size: 100 });
      setDocumenti(res.data.content || []);
      setTotalPages(res.data.totalPages || 0);
      setPage(res.data.number || 0);
    } catch (err) {
      console.error("Errore caricamento documenti:", err);
      setErr(extractErrorMessage(err));
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortField(field);
      setSortDirection('ASC');
    }
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'ASC' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };

  const fetchScadenze = async () => {
    try {
      const res = await scadenzaApi.listbycontribuente(id, { page: 0, size: 1000 });
      const all = res.data.content || [];
      setScadenze(all);

      const today = new Date();
      today.setHours(0,0,0,0);

      const prossime = [];
      const scadute = [];
      const prossimeentrata = [];
      const scaduteentrata = [];

      all.forEach(s => {
        const dataScad = new Date(s.dataScadenza);
        dataScad.setHours(0,0,0,0);
        const diffGiorni = (dataScad - today) / (1000 * 60 * 60 * 24);

        if (diffGiorni < 0 && s.stato !== 'pagata' && s.direzione!=='ENTRATA') scadute.push(s);
        else if (diffGiorni >= 0 && diffGiorni <= 7 && s.stato !== 'pagata' && s.direzione!=='ENTRATA') prossime.push(s);

        if (diffGiorni < 0 && s.stato !== 'pagata' && s.direzione==='ENTRATA') scaduteentrata.push(s);
        else if (diffGiorni >= 0 && diffGiorni <= 7 && s.stato !== 'pagata' && s.direzione==='ENTRATA') prossimeentrata.push(s);


      });

      setListScadenzeScadute(scadute);
      setListScadenzeProssime(prossime);
      setListScadenzeScaduteEntrata(scaduteentrata);
      setListScadenzeProssimeEntrata(prossimeentrata);
      setScadenzeScadute(scadute.length);
      setScadenzeProssime(prossime.length);
      setScadenzeScaduteEntrata(scaduteentrata.length);
      setScadenzeProssimeEntrata(prossimeentrata.length);

    } catch (err) {
      console.error("Errore caricamento scadenze:", err);
      setErr(extractErrorMessage(err));
    }
  };

const openPdf = async (filename) => {
  try {
    setLoading(true);
    const response = await filesApi.getfile(filename);
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
    setErr(extractErrorMessage(err));
    alert("Impossibile aprire il PDF");
  }finally{
    setLoading(false);
  }
};

  const confirmDelete = (id, type) => {
    setSelectedId(id);
    setDeleteType(type);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
        setLoading(true);
      if(deleteType === 'doc') await documentoApi.delete(selectedId);
      else if(deleteType === 'scad') await scadenzaApi.delete(selectedId);

      fetchDocumenti();
      fetchScadenze();
    } catch(err) {
      console.error("Errore eliminazione:", err);
      setErr(extractErrorMessage(err));
    } finally {
      setOpenDelete(false);
      setSelectedId(null);
      setDeleteType('');
      setLoading(false);
    }
  };

      const handleDownload = async (documentoId, fileName) => {
        try {
          setLoading(true);
          const response = await documentoApi.downloadDocumento(documentoId, fileName);
          const url = window.URL.createObjectURL(
                                new Blob([response.data], { type: 'application/pdf' })
                              );
          window.open(url, '_blank');
        } catch (err) {
          console.error(err);
        } finally {
               setLoading(false);
             }
      };

  if(!contribuente) return <div>Loading...</div>;

  return (
    <Container>
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
          }}
        >
          <CircularProgress size={48}/>
        </Box>
      )}
      <Typography variant="h4" sx={{ mb: 2 }}>
        Benvenuto {contribuente.nome} {contribuente.cognome}
      </Typography>

      {/* KPI CARD */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">Documenti</Typography>
              <Typography variant="h5">{documenti.length}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">Scadenze totali (entrata/uscita)</Typography>
              <Typography variant="h5">{scadenze.length}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">Scadenze prossime (uscita) (&lt;7gg)</Typography>
              <Typography variant="h5">{scadenzeProssime}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">Scadenze scadute (uscita)</Typography>
              <Typography variant="h5">{scadenzeScadute}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">Scadenze prossime (entrata) (&lt;7gg)</Typography>
              <Typography variant="h5">{scadenzeProssimeEntrata}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2">Scadenze scadute (entrata)</Typography>
              <Typography variant="h5">{scadenzeScaduteEntrata}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Informazioni Contribuente */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography>Codice Fiscale: {contribuente.codiceFiscale}</Typography>
          <Typography>Partita IVA: {contribuente.partitaIVA}</Typography>
          <Typography>Tipo contratto: {contribuente.contratto ? contribuente.contratto.tipocontratto.tipo : '—'}</Typography>
          <Typography>Canone annuo contratto: {contribuente.contratto ? contribuente.contratto.canoneAnnuo : '—'}</Typography>
          <Typography>Scadenza contratto: {contribuente.contratto ?  formatDate(contribuente.contratto.dataFine): '—'}</Typography>
          <ProtectedAction user={user} contractState={user.statoContratto}>
          <Button
            variant="outlined"
            sx={{ mt: 1 }}
            onClick={() => navigate(`/contribuenti/${id}/documenti/upload`)}
          >
            Upload PDF
          </Button></ProtectedAction>
        </CardContent>
      </Card>

      {/* Liste rapide documenti */}
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchDocumenti(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>
      <Typography variant="h6" sx={{ mt: 2 }}>Documenti recenti</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell onClick={() => handleSort('tipo')} style={{ cursor: 'pointer' }}>Tipo</TableCell>
            <TableCell>PDF</TableCell>
            <TableCell>Rate saltate</TableCell>
              <TableCell onClick={() => handleSort('dataCreazione')} style={{ cursor: 'pointer' }}>
                Data Creazione {renderSortIcon('dataCreazione')}
              </TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documenti.map(d => (
            <TableRow key={d.id}>
              <TableCell>{d.tipo}</TableCell>
<TableCell>
  {d.pdfPath ? (
    <Button
      variant="outlined"
      size="small"
      onClick={async () => {
        try {
          const res = await filesApi.getfile(d.pdfPath);
          const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          window.open(url, '_blank');
        } catch (err) {
          console.error('Errore apertura PDF:', err);
        }
      }}
    >
      Apri
    </Button>
  ) : (
    'Nessuno'
  )}
</TableCell>
              <TableCell>
                {d.rateSaltate > 0 ? (
                  <Badge color="error" badgeContent={d.rateSaltate}><span/></Badge>
                ) : d.rateSaltate}
              </TableCell>
              <TableCell>{formatDate(d.dataCreazione)}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/documenti/${d.id}`)}><Visibility/></IconButton>
                  <ProtectedAction user={user} contractState={user.statoContratto}>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/documenti/edit/${d.id}`)}><Edit/></IconButton>
                  <IconButton color="error" size="small" onClick={() => confirmDelete(d.id,'doc')}><Delete/></IconButton>
                  </ProtectedAction>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
<Stack direction="row" spacing={1} sx={{ mt: 2 }}>
  {Array.from({ length: totalPages }, (_, i) => (
    <Button
      key={i}
      variant={i === page ? "contained" : "outlined"}
      onClick={() => fetchDocumenti(i)}
    >
      {i + 1}
    </Button>
  ))}
</Stack>
      {/* Liste rapide scadenze */}
<Typography variant="h6" sx={{ mt: 3, color: 'error.main' }}>
  Scadenze scadute (uscita) (le prime 5 partendo dalle più vecchie)
</Typography>

<Table>
  <TableHead>
    <TableRow>
      <TableCell>Tipo</TableCell>
      <TableCell>Data</TableCell>
      <TableCell>Codice pagamento</TableCell>
      <TableCell>Stato</TableCell>
      <TableCell>Importo</TableCell>
      <TableCell>File</TableCell>
      <TableCell>Marca come pagata</TableCell>
      <TableCell>Azioni</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {listscadenzescadute.slice(0, pageSize).map(s => {
     const cfg = scadenzaStatusMap[s.direzione!="ENTRATA"?s.stato:s.stato!="pagata"?"da_incassare":s.stato];
      return (
      <TableRow key={s.id}>
        <TableCell>{s.tipo}</TableCell>
        <TableCell>{formatDate(s.dataScadenza)}</TableCell>
        <TableCell>{s.codiceModuloPagamento}</TableCell>
        <TableCell>
          <Chip label={cfg?.label || s.stato} color={cfg?.color || 'default'} size="small" />
        </TableCell>
        <TableCell>{s.importo}</TableCell>
        <TableCell>
                {/* PDF  */}
                {s.pdfPath && (
                     <Tooltip title="download file">
                      <IconButton
                      color="error"
                      size="small"
                        onClick={() => handleDownload(s.documentoId, s.pdfPath)}
                      >
                        <PictureAsPdf />
                      </IconButton>
                      </Tooltip>
                )}
                </TableCell>
              <TableCell>
                              { s.stato !== "pagata" && (
                                <Stack direction="row" spacing={1}>
                                <ProtectedAction user={user} contractState={user.statoContratto}>
                                  <Tooltip title="marca come pagata">
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={async () => {
                                      try {
                                         setLoading(true);
                                        // chiama rotta interna per marcare pagata senza email
                                        await scadenzaApi.setpagatamanuale(s.id);
                                        fetchScadenze();
                                      } catch (err) {
                                        console.error('Errore marcatura manuale pagamento:', err);
                                      } finally{
                                         setLoading(false);
                                      }
                                    }}
                                  >
                                    <PaymentIcon />
                                  </IconButton></Tooltip></ProtectedAction>
                                </Stack>
                              )}
              </TableCell>
            <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/scadenze/${s.id}`)}><Visibility/></IconButton>
                  <ProtectedAction user={user} contractState={user.statoContratto}>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/scadenze/edit/${s.id}`)}><Edit/></IconButton>
                  </ProtectedAction>
                </Stack>
              </TableCell>
      </TableRow>
      );
    })}
    {listscadenzescadute.length === 0 && (
      <TableRow>
        <TableCell colSpan={4} align="center">
          Nessuna scadenza scaduta in uscita
        </TableCell>
      </TableRow>
    )}
  </TableBody>
</Table>
<Typography variant="h6" sx={{ mt: 3, color: 'warning.main' }}>
  Scadenze prossime (uscita) (le prime 5 partendo dalle più vecchie)
</Typography>

<Table>
  <TableHead>
    <TableRow>
      <TableCell>Tipo</TableCell>
      <TableCell>Data</TableCell>
    <TableCell>Codice pagamento</TableCell>
    <TableCell>Importo</TableCell>
    <TableCell>File</TableCell>
    <TableCell>Stato</TableCell>
    <TableCell>Pagamento</TableCell>
    <TableCell>Marca come pagata</TableCell>
      <TableCell>Azioni</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {listscadenzeprossime.slice(0, pageSize).map(s => {
      const cfg = scadenzaStatusMap[s.stato];
      return (
      <TableRow key={s.id}>
        <TableCell>{s.tipo}</TableCell>
        <TableCell>{formatDate(s.dataScadenza)}</TableCell>
        <TableCell>{s.codiceModuloPagamento}</TableCell>
                <TableCell>{s.importo}</TableCell>
                <TableCell>
                {/* PDF  */}
                {s.pdfPath && (
                     <Tooltip title="download file">
                      <IconButton
                      color="error"
                      size="small"
                        onClick={() => handleDownload(s.documentoId, s.pdfPath)}
                      >
                        <PictureAsPdf />
                      </IconButton>
                      </Tooltip>
                )}
                </TableCell>
                <TableCell>
                  <Chip label={cfg?.label || s.stato} color={cfg?.color || 'default'} size="small" />
                </TableCell>
                <TableCell>{formatDate(s.dataPagamento)}</TableCell>
                <TableCell>
                { s.stato !== "pagata" && (
                            <Stack direction="row" spacing={1}>
                                <ProtectedAction user={user} contractState={user.statoContratto}>
                                  <Tooltip title="marca come pagata">
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={async () => {
                                      try {
                                         setLoading(true);
                                        // chiama rotta interna per marcare pagata senza email
                                        await scadenzaApi.setpagatamanuale(s.id);
                                        fetchScadenze();
                                      } catch (err) {
                                        console.error('Errore marcatura manuale pagamento:', err);
                                      } finally{
                                         setLoading(false);
                                      }
                                    }}
                                  >
                                    <PaymentIcon />
                                  </IconButton></Tooltip></ProtectedAction>
                                </Stack>
                )}
                  </TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/scadenze/${s.id}`)}><Visibility/></IconButton>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/scadenze/edit/${s.id}`)}><Edit/></IconButton>
                </Stack>
              </TableCell>
      </TableRow>
    )})}
    {listscadenzeprossime.length === 0 && (
      <TableRow>
        <TableCell colSpan={4} align="center">
          Nessuna scadenza in uscita nei prossimi 7 giorni
        </TableCell>
      </TableRow>
    )}
  </TableBody>
</Table>
<Typography variant="h6" sx={{ mt: 3, color: 'error.main' }}>
  Scadenze scadute (entrata) (le prime 5 partendo dalle più vecchie)
</Typography>

<Table>
  <TableHead>
    <TableRow>
      <TableCell>Tipo</TableCell>
      <TableCell>Data</TableCell>
      <TableCell>Codice pagamento</TableCell>
      <TableCell>Stato</TableCell>
      <TableCell>Importo</TableCell>
      <TableCell>File</TableCell>
      <TableCell>Marca come pagata</TableCell>
      <TableCell>Azioni</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {listscadenzescaduteentrata.slice(0, pageSize).map(s => {
     const cfg = scadenzaStatusMap[s.direzione!="ENTRATA"?s.stato:s.stato!="pagata"?"da_incassare":s.stato];
      return (
      <TableRow key={s.id}>
        <TableCell>{s.tipo}</TableCell>
        <TableCell>{formatDate(s.dataScadenza)}</TableCell>
        <TableCell>{s.codiceModuloPagamento}</TableCell>
        <TableCell>
          <Chip label={cfg?.label || s.stato} color={cfg?.color || 'default'} size="small" />
        </TableCell>
        <TableCell>{s.importo}</TableCell>
        <TableCell>
                {/* PDF  */}
                {s.pdfPath && (
                     <Tooltip title="download file">
                      <IconButton
                      color="error"
                      size="small"
                        onClick={() => handleDownload(s.documentoId, s.pdfPath)}
                      >
                        <PictureAsPdf />
                      </IconButton>
                      </Tooltip>
                )}
                </TableCell>
              <TableCell>
                              { s.stato !== "pagata" && (
                                <Stack direction="row" spacing={1}>
                                <ProtectedAction user={user} contractState={user.statoContratto}>
                                  <Tooltip title="marca come pagata">
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={async () => {
                                      try {
                                         setLoading(true);
                                        // chiama rotta interna per marcare pagata senza email
                                        await scadenzaApi.setpagatamanuale(s.id);
                                        fetchScadenze();
                                      } catch (err) {
                                        console.error('Errore marcatura manuale pagamento:', err);
                                      } finally{
                                         setLoading(false);
                                      }
                                    }}
                                  >
                                    <PaymentIcon />
                                  </IconButton></Tooltip></ProtectedAction>
                                </Stack>
                              )}
              </TableCell>
            <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/scadenze/${s.id}`)}><Visibility/></IconButton>
                  <ProtectedAction user={user} contractState={user.statoContratto}>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/scadenze/edit/${s.id}`)}><Edit/></IconButton>
                  </ProtectedAction>
                </Stack>
              </TableCell>
      </TableRow>
      );
    })}
    {listscadenzescaduteentrata.length === 0 && (
      <TableRow>
        <TableCell colSpan={4} align="center">
          Nessuna scadenza scaduta in entrata
        </TableCell>
      </TableRow>
    )}
  </TableBody>
</Table>
<Typography variant="h6" sx={{ mt: 3, color: 'warning.main' }}>
  Scadenze prossime (entrata) (le prime 5 partendo dalle più vecchie)
</Typography>

<Table>
  <TableHead>
    <TableRow>
      <TableCell>Tipo</TableCell>
      <TableCell>Data</TableCell>
    <TableCell>Codice pagamento</TableCell>
    <TableCell>Importo</TableCell>
    <TableCell>File</TableCell>
    <TableCell>Stato</TableCell>
    <TableCell>Pagamento</TableCell>
    <TableCell>Marca come pagata</TableCell>
      <TableCell>Azioni</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {listscadenzeprossimeentrata.slice(0, pageSize).map(s => {
      const cfg = scadenzaStatusMap[s.direzione!="ENTRATA"?s.stato:s.stato!="pagata"?"da_incassare":s.stato];
      return (
      <TableRow key={s.id}>
        <TableCell>{s.tipo}</TableCell>
        <TableCell>{formatDate(s.dataScadenza)}</TableCell>
        <TableCell>{s.codiceModuloPagamento}</TableCell>
                <TableCell>{s.importo}</TableCell>
                <TableCell>
                {/* PDF  */}
                {s.pdfPath && (
                     <Tooltip title="download file">
                      <IconButton
                      color="error"
                      size="small"
                        onClick={() => handleDownload(s.documentoId, s.pdfPath)}
                      >
                        <PictureAsPdf />
                      </IconButton>
                      </Tooltip>
                )}
                </TableCell>
                <TableCell>
                  <Chip label={cfg?.label || s.stato} color={cfg?.color || 'default'} size="small" />
                </TableCell>
                <TableCell>{formatDate(s.dataPagamento)}</TableCell>
                <TableCell>
                { s.stato !== "pagata" && (
                            <Stack direction="row" spacing={1}>
                                <ProtectedAction user={user} contractState={user.statoContratto}>
                                  <Tooltip title="marca come pagata">
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={async () => {
                                      try {
                                         setLoading(true);
                                        // chiama rotta interna per marcare pagata senza email
                                        await scadenzaApi.setpagatamanuale(s.id);
                                        fetchScadenze();
                                      } catch (err) {
                                        console.error('Errore marcatura manuale pagamento:', err);
                                      } finally{
                                         setLoading(false);
                                      }
                                    }}
                                  >
                                    <PaymentIcon />
                                  </IconButton></Tooltip></ProtectedAction>
                                </Stack>
                )}
                  </TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/scadenze/${s.id}`)}><Visibility/></IconButton>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/scadenze/edit/${s.id}`)}><Edit/></IconButton>
                </Stack>
              </TableCell>
      </TableRow>
    )})}
    {listscadenzeprossimeentrata.length === 0 && (
      <TableRow>
        <TableCell colSpan={4} align="center">
          Nessuna scadenza in entrata nei prossimi 7 giorni
        </TableCell>
      </TableRow>
    )}
  </TableBody>
</Table>
      <ConfirmDialog
        open={openDelete}
        onCancel={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        title="Conferma Eliminazione"
        message="Sei sicuro di voler eliminare questo elemento?"
      />
    </Container>
  );
}